const addButtons = document.querySelectorAll('.cartAddBtn');
addButtons.forEach(item => {
  item.addEventListener('click', () => {
    const variantId = item.getAttribute('data-variant-id');
    cartAdd(variantId);
  });
});

// モーダル表示・非表示
const cartModal = document.querySelector('.item-list__modal');
const modalTriggers = document.querySelectorAll(
  '.modalOpen, .item-list__close, .item-list__overlay'
);

modalTriggers.forEach(trigger => {
  trigger.addEventListener('click', () => {
    if (cartModal.classList.contains('is-show')) {
      // モーダルを非表示にする場合
      cartModal.animate([{ opacity: '1' }, { opacity: '0' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      }).onfinish = () => {
        cartModal.style.display = 'none';
        cartModal.classList.toggle('is-show');
      };
    } else {
      // モーダルを表示する場合
      cartModal.style.opacity = 0;
      cartModal.style.display = 'block';
      cartModal.classList.toggle('is-show');
      cartModal.animate([{ opacity: '0' }, { opacity: '1' }], {
        duration: 500,
        easing: 'ease-in-out',
        fill: 'forwards',
      });
    }
  });
});

// カートに追加し、カート画面へ遷移
const cartAdd = async variantId => {
  if (variants.length !== 0) {
    for (const variant of variants) {
      if (variant.id === variantId) {
        await staffStart.cart.sendTrackingRequest('6cfe160cc150f04754367b05e711b987', {
          product_code: variant.sku,
          count: '1',
        });
      }
    }
  }

  // カートの現在の状態を取得
  const cart = await fetch('/cart.js').then(res => res.json());

  let variantExistsInCart = false;

  // カート内の商品を確認し、すでにカートに存在すれば数量を追加
  for (const item of cart.items) {
    if (item.id === Number(variantId)) {
      variantExistsInCart = true;
      const updatedQuantity = item.quantity + 1;

      // カートのアイテム数量を更新
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates: { [variantId]: updatedQuantity } }),
      })
        .then(res => {
          if (res.ok) {
            window.location = '/cart';
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });

      break;
    }
  }

  // 商品がカート内に存在しない場合、新しいアイテムとして追加
  if (!variantExistsInCart) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        dataType: 'json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            quantity: 1,
            id: variantId,
          },
        ],
      }),
    })
      .then(res => {
        if (res.ok) {
          window.location = '/cart';
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  gtmCartFunc();
};
